import { HistoryPopupBanner } from './HistoryPopupBanner'
import { withHistoryPopupBanner } from './withHistoryPopupBanner'

const ConnectedHistoryPopupBanner = withHistoryPopupBanner(HistoryPopupBanner)
export { ConnectedHistoryPopupBanner as HistoryPopupBanner }
